/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SequenceResponseEnrollmentBlockedReason } from './sequenceResponseEnrollmentBlockedReason';
import type { SequenceRules } from './sequenceRules';
import type { SequenceSchedule } from './sequenceSchedule';
import type { SequenceStepSetResponse } from './sequenceStepSetResponse';

/**
 * Full read shape returned by GET / POST / PATCH endpoints.
 *
 * Includes the nested ``current_step_set`` (with steps) so the
 * Sequence Detail page can render in a single round-trip.
 */
export interface SequenceResponse {
  id: string;
  org_id: string;
  project_id: string;
  job_id: string;
  name: string;
  description?: string | null;
  sender_user_id: string;
  mailbox_id: string;
  is_archived?: boolean;
  current_step_set_id?: string | null;
  schedule?: SequenceSchedule;
  rules?: SequenceRules;
  archived_at?: string | null;
  created_at: string;
  updated_at: string;
  created_by_user_id: string;
  current_step_set?: SequenceStepSetResponse | null;
  enrollment_blocked_reason?: SequenceResponseEnrollmentBlockedReason;
}
